module.exports = __webpack_public_path__ + "5340036018e48e8e61a7e8a1f562277d.pdf";